import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import BackToTop from '../../components/elements/BackToTop';
import Header from '../../components/Layout/Header';
import navImg1 from '../../assets/images/resources/logo-1.png';
import Footer from '../../components/Layout/Footer';
import HomeThreeMain from '../home-3/HomeThreeMain';



const Services = () => {

    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener("scroll", handleScroll);
        return () => document.removeEventListener("scroll", handleScroll);
    }, []);
    return (
        <React.Fragment>
            <Helmet>
                <title>Services - U Brand It Promotional Products</title>
                <meta name="description" content="Explore our wide range of promotional products and services including custom apparel, corporate gifts, event materials, and branded merchandise." />
                <meta name="keywords" content="promotional products services, custom apparel, corporate gifts, event materials, branded merchandise, promotional items" />
                <link rel="canonical" href="https://ubranditpa.com/services" />
                
                {/* Open Graph */}
                <meta property="og:title" content="Services - U Brand It Promotional Products" />
                <meta property="og:description" content="Explore our wide range of promotional products and services including custom apparel, corporate gifts, event materials, and branded merchandise." />
                <meta property="og:url" content="https://ubranditpa.com/services" />
                <meta property="og:type" content="website" />
            </Helmet>
            <Header
                navImg={navImg1}
                parentMenu='services'
                activeMenu="/services"
            />
            <HomeThreeMain/>
            <BackToTop scroll={isVisible} />
            <Footer />
        </React.Fragment>
    );
}

export default Services;